import React from 'react';
import Sidebar from '../components/Sidebar';
import { Container } from 'react-bootstrap';
import BrandRouterCard from '../components/BrandRouterCard';

function AdminBrandRouterPage() {
  const [collapsed, setCollapsed] = React.useState(false);
  return (
    <div className="d-flex">
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      <Container
        fluid
        className="pt-4"
        style={{ marginLeft: collapsed ? '60px' : '220px', transition: 'margin-left 0.3s ease' }}
      >
        <BrandRouterCard />
      </Container>
    </div>
  );
}

export default AdminBrandRouterPage;
